const PRODUCTS = {
  locambioSeguro: 'LocambioSeguro',
  locambioPromo: 'LocambioPromo',
};

const productsExport = {
  PRODUCTS,
};

export default productsExport;